export const ROUTE_HOME = 'home';
export const ROUTE_ABOUT = 'about';
export const ROUTE_PRODUCTION = 'production';
export const ROUTE_PLAN = 'plan';
export const ROUTE_JOIN = 'join';
export const ROUTE_JOIN_DETAIL = 'joinDetail';
export const ROUTE_NEWS = 'news';
export const ROUTE_NEW_DETAIL = 'newDetail';
export const ROUTE_PROJECT = 'project';
export const ROUTE_PROJECT_DETAIL = 'projectDetail'